
import { useFetchDomainSetupProcessQuery } from '../service';
import { useEffect, useState } from 'react';
import { ProcessStatus } from '../../../process/types';


const FINISHED_STATUSES: ProcessStatus[] = ['completed', 'failed', 'timeout', 'aborted'];

export default function useDomainSetupProgress(domain: string, processGuid: string) {
    const [hasFinished, setHasFinished] = useState<boolean>(false);

    const { data: domainSetupProcess, isLoading } = useFetchDomainSetupProcessQuery(
        { domain, processGuid },
        {
            pollingInterval: hasFinished ? 0 : 5000,
            refetchOnMountOrArgChange: true,
        }
    );

    useEffect(() => {
        if (domainSetupProcess && FINISHED_STATUSES.includes(domainSetupProcess.status)) {
            setHasFinished(true);
        }
    }, [domainSetupProcess]);

    return {
        homepageUrl: domainSetupProcess?.output?.homepage_url || null,
        competitors: domainSetupProcess?.output?.competitors || null,
        topKeywords: domainSetupProcess?.output?.top_keywords || null,
        monitoringRegions: domainSetupProcess?.output?.uptime_monitoring_regions || null,
        searchEngineMarket: domainSetupProcess?.output?.search_engine_market || null,
        processError: domainSetupProcess?.output?.error || null,
        hasFinished,
        isLoading
    };
}
